import { CLOSE_SURVEY_MODAL, OPEN_SURVEY_MODAL } from './types';

export const openSurveyModal = () => ({
  type: OPEN_SURVEY_MODAL,
});
export const closeSurveyModal = () => ({ type: CLOSE_SURVEY_MODAL });
